export default {
  methods: {
    toPersianDigits(number) {
      if (number == undefined || number == null) return;
      number = number.toString();
      const find = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      const replace = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      for (let i = 0; i < find.length; i++) {
        number = number.replace(new RegExp(find[i], "g"), replace[i]);
      }
      return number;
    },
    toEnglishDigits(number) {
      if (number !== undefined) {
        number = number.toString();
        const find = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        const replace = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        for (let i = 0; i < find.length; i++) {
          number = number.replace(new RegExp(find[i], "g"), replace[i]);
        }
        return number;
      }
    },
    successToast(text) {
      this.$toast.add({
        severity: 'success',
        detail: text,
        life: 3000,
        summary: "موفق"
        
      });
    },
    errorToast(text) {
      this.$toast.add({
        severity: 'error',
        detail: text,
        life: 3000,
        summary: "ناموفق"
      });
    },
    infoToast(text) {
      this.$toast.add({
        severity: 'info',
        detail: text,
        life: 3000,
        summary: "اطلاعیه"
      });
    },
    warningToast(text) {
      this.$toast.add({
        severity: 'warn',
        detail: text, 
        life: 3000,
        summary: "هشدار"
      });
    },

    newLineToBr(text) {
      if (text) {
        return text.replace(/\n/g, "<br />");
      }
    },
  },
};
